import _ from 'lodash';
export const THUMBNAIL_WIDTH_BREAKPOINTS = [275, 399,
// before height jump because of dependant of thumb width media-query
400,
// after jump
500, 700];
export const CONTENT_CONFIG = {
  defaults: {
    marginTop: '6px',
    marginLeft: '15px',
    marginRight: '15px',
    paddingTop: '15px'
  },
  breakpoints: {
    400: {
      marginLeft: '20px',
      marginRight: '20px',
      paddingTop: '14px'
    },
    500: {
      paddingTop: '20px'
    }
  }
};
export const PUBLISHER_CONFIG = {
  defaults: {
    marginBottom: '11px',
    fontSize: '12px',
    lineHeight: 1.17
  },
  breakpoints: {
    400: {
      marginBottom: '13.5px',
      fontSize: '14px'
    },
    700: {
      fontSize: '16px'
    }
  }
};
export const TITLE_CONFIG = {
  defaults: {
    fontSize: '14px',
    lineHeight: 1.43,
    marginBottom: '8px'
  },
  breakpoints: {
    400: {
      marginBottom: '11.5px',
      fontSize: '18px',
      lineHeight: 1.5
    },
    700: {
      fontSize: '20px',
      lineHeight: 1.45
    }
  }
};
export const DESCRIPTION_CONFIG = {
  defaults: {
    fontSize: '12px',
    lineHeight: 1.67
  },
  breakpoints: {
    400: {
      fontSize: '14px',
      lineHeight: 1.7
    },
    700: {
      fontSize: '16px',
      lineHeight: 1.69
    }
  }
};
const getStylesForWidth = stylesConfig => width => {
  let styles = stylesConfig.defaults;
  _(THUMBNAIL_WIDTH_BREAKPOINTS).takeWhile(breakpoint => breakpoint <= width).forEach(breakpoint => {
    const st = stylesConfig.breakpoints[breakpoint];
    if (st) {
      styles = {
        ...styles,
        ...st
      };
    }
  });
  return styles;
};
const getContentStyles = getStylesForWidth(CONTENT_CONFIG);
const getPublisherStyles = getStylesForWidth(PUBLISHER_CONFIG);
const toNumber = value => typeof value === 'number' ? value : parseFloat(value);
const getFontStyle = (size, lineHeight) => {
  const sizeNumber = toNumber(size);
  if (typeof lineHeight === 'number') {
    lineHeight = lineHeight * sizeNumber + "px";
  }
  return {
    lineHeight,
    fontSize: size,
    maxHeight: parseFloat(lineHeight) * 2 + "px"
  };
};
const getTitleStyles = _ref => {
  let {
    width,
    isOptimalFontSizes,
    titleFont
  } = _ref;
  const title = getStylesForWidth(TITLE_CONFIG)(width);
  let fontStyles;
  if (isOptimalFontSizes) {
    fontStyles = getFontStyle(title.fontSize, title.lineHeight);
  } else {
    fontStyles = getFontStyle(titleFont.size, titleFont.lineHeight || 1.4);
  }
  return {
    ...title,
    ...fontStyles
  };
};
const getDescriptionStyles = _ref2 => {
  let {
    width,
    textFont,
    isOptimalFontSizes
  } = _ref2;
  const description = getStylesForWidth(DESCRIPTION_CONFIG)(width);
  return {
    ...description,
    ...(isOptimalFontSizes ? getFontStyle(description.fontSize, description.lineHeight) : getFontStyle(textFont.size, description.lineHeight))
  };
};
export const getStyles = _ref3 => {
  let {
    width = 275,
    isOptimalFontSizes = false,
    titleFont,
    textFont
  } = _ref3;
  return {
    content: getContentStyles(width),
    publisher: getPublisherStyles(width),
    title: getTitleStyles({
      width,
      isOptimalFontSizes,
      titleFont
    }),
    description: getDescriptionStyles({
      width,
      isOptimalFontSizes,
      textFont
    })
  };
};
const getHeight = styles => {
  const {
    marginTop = 0,
    marginBottom = 0,
    paddingTop = 0,
    maxHeight,
    fontSize,
    lineHeight
  } = styles;
  let contentHeight = 0;
  if (maxHeight) {
    contentHeight = parseFloat(maxHeight);
  } else if (fontSize && lineHeight) {
    contentHeight = toNumber(fontSize) * toNumber(lineHeight);
  }
  return contentHeight + toNumber(marginTop) + toNumber(marginBottom) + toNumber(paddingTop);
};
export const getContentHeight = _ref4 => {
  let {
    width = 275,
    isOptimalFontSizes = false,
    titleFont,
    textFont,
    withPublisher,
    withTitle,
    withDescription
  } = _ref4;
  const {
    content,
    publisher,
    title,
    description
  } = getStyles({
    width,
    isOptimalFontSizes,
    textFont,
    titleFont
  });
  return getHeight(content) + (withPublisher ? getHeight(publisher) : 0) + (withTitle ? getHeight(title) : 0) + (withDescription ? getHeight(description) : 0);
};
//# sourceMappingURL=content.config.js.map